/**
 * Querysleutels voor de eigen omgeving buiten Instellingen. `current` is dezelfde
 * sleutel als `settingsKeys.tenant`, zodat het dashboard en Instellingen één kopie
 * van het bedrijf delen: een opgeslagen KvK-nummer is meteen ook op het dashboard
 * afgevinkt.
 */
export const tenantKeys = {
    current: ['tenant'] as const,
    pricing: ['pricing'] as const,
};
